import Cookie from 'js-cookie';
import moment from 'moment-timezone';
import { put, takeLatest, select } from 'redux-saga/effects';
import initialUserPreferences from '../reducers/userPreferencesReducer';
import {
  REHYDRATE_STORE_REQUEST,
  REHYDRATE_STORE,
  SELECT_CITY_REQUEST,
  SELECT_CITY,
  SELECT_GUEST_AMOUNT_REQUEST,
  SELECT_GUEST_AMOUNT,
  SELECT_DATE_REQUEST,
  SELECT_DATE,
  SELECT_PRODUCT_REQUEST,
  SELECT_PRODUCT,
  SELECT_EXPERIENCE_REQUEST,
  SELECT_EXPERIENCE,
  SELECT_SORT_TYPE_REQUEST,
  SELECT_SORT_TYPE,
  SELECT_DISTANCE_REQUEST,
  SELECT_DISTANCE,
  SELECT_PRICE_REQUEST,
  SELECT_PRICE,
  SELECT_CITY_DEFAULT_REQUEST,
  SELECT_GUEST_AMOUNT_DEFAULT_REQUEST,
  SELECT_DATE_DEFAULT_REQUEST,
  SELECT_PRODUCT_DEFAULT_REQUEST,
  SELECT_EXPERIENCE_DEFAULT_REQUEST,
  SELECT_SORT_TYPE_DEFAULT_REQUEST,
  SELECT_DISTANCE_DEFAULT_REQUEST,
  SELECT_PRICE_DEFAULT_REQUEST,
  SELECT_CITY_DEFAULT,
  SELECT_GUEST_AMOUNT_DEFAULT,
  SELECT_DATE_DEFAULT,
  SELECT_PRODUCT_DEFAULT,
  SELECT_EXPERIENCE_DEFAULT,
  SELECT_SORT_TYPE_DEFAULT,
  SELECT_DISTANCE_DEFAULT,
  SELECT_PRICE_DEFAULT, OPEN_CHECKOUT_SUBSCRIPTION_PAGE, SELECT_PAYMENT_METHOD,
} from '../types';
import { cookieName, version } from '../../utils';

const populateCookieStorage = (value, type) => {
  const userPreferences = Cookie.get(cookieName) || '{}';
  const parsedUserPreferences = JSON.parse(userPreferences);

  if (parsedUserPreferences.version !== version) {
    Cookie.remove(cookieName);
  }

  Cookie.set(cookieName, {
    ...parsedUserPreferences,
    [type]: value,
    version,
  }, { path: '/' });
};

function* rehydrateStore({ payload: userPreferences }) {
  if (userPreferences.version === version) {
    let selectedDate = userPreferences.date || moment().format('YYYY-MM-DD');

    if (moment(userPreferences.date).isBefore(moment())) {
      selectedDate = moment().format('YYYY-MM-DD');
    }
    yield put({ type: REHYDRATE_STORE, payload: {...userPreferences, date: moment(selectedDate).format('YYYY-MM-DD') } })
  }
}

function* selectCity({ payload: city }) {
 const transformedCity = {
   label: city.label,
   value: city.value,
   type: city.type,
   id: city.id,
   market: city.market,
   adminCode: city.adminCode,
   coordinates: city.coordinates,
 };

 populateCookieStorage(transformedCity, 'city');
 yield put({ type: SELECT_CITY, payload: transformedCity });
}

function* selectCityDefault() {
  populateCookieStorage(initialUserPreferences.city, 'city');
  yield put({ type: SELECT_CITY_DEFAULT });
 }

function* selectGuests({ payload: guests }) {
 populateCookieStorage(guests, 'guests');
 yield put({ type: SELECT_GUEST_AMOUNT, payload: guests })
}

function* selectGuestsDefault() {
  populateCookieStorage(initialUserPreferences.guests, 'guests');
  yield put({ type: SELECT_GUEST_AMOUNT_DEFAULT })
 }

function* selectDate({ payload: date }) {
 populateCookieStorage(date, 'date');
 yield put({ type: SELECT_DATE, payload: date })
}

function* selectDateDefault() {
  populateCookieStorage(initialUserPreferences.date, 'date');
  yield put({ type: SELECT_DATE_DEFAULT })
 }

function* selectProduct({ payload: product }) {
 populateCookieStorage(product, 'product');
 yield put({ type: SELECT_PRODUCT, payload: product })
}

function* selectProductDefault() {
  populateCookieStorage(initialUserPreferences.product, 'product');
  yield put({ type: SELECT_PRODUCT_DEFAULT})
 }

function* selectExperience({ payload: experience }) {
 populateCookieStorage(experience, 'experience');
 yield put({ type: SELECT_EXPERIENCE, payload: experience })
}

function* selectExperienceDefault() {
  populateCookieStorage(initialUserPreferences.experience, 'experience');
  yield put({ type: SELECT_EXPERIENCE_DEFAULT })
 }

function* selectSortType({ payload: sortType }) {
 populateCookieStorage(sortType, 'sortType');
 yield put({ type: SELECT_SORT_TYPE, payload: sortType });
}

function* selectSortTypeDefault() {
  populateCookieStorage(initialUserPreferences.sortType, 'sortType');
  yield put({ type: SELECT_SORT_TYPE_DEFAULT });
 }

function* selectDistance({ payload: distance }) {
 populateCookieStorage(distance, 'distance');
 yield put({ type: SELECT_DISTANCE, payload: distance });
}

function* selectDistanceDefault() {
 populateCookieStorage(initialUserPreferences.distanceObject, 'distance');
 yield put({ type: SELECT_DISTANCE_DEFAULT });
}

function* selectPrice({ payload: price }) {
 populateCookieStorage(price, 'price');
 yield put({ type: SELECT_PRICE, payload: price });
}

function* selectPriceDefault() {
 populateCookieStorage(initialUserPreferences.priceObject, 'price');
 yield put({ type: SELECT_PRICE_DEFAULT });
}

function* selectCardDefault() {
  const user = yield select(state => state.user);

  if (user.userData && user.cards && user.cards[1]) {
    yield put({ type: SELECT_PAYMENT_METHOD, payload: user.cards[1].options[0] });
  }
}

export default function* saga() {
  yield takeLatest(REHYDRATE_STORE_REQUEST, rehydrateStore);
  yield takeLatest(SELECT_CITY_REQUEST, selectCity);
  yield takeLatest(SELECT_CITY_DEFAULT_REQUEST, selectCityDefault);
  yield takeLatest(SELECT_GUEST_AMOUNT_REQUEST, selectGuests);
  yield takeLatest(SELECT_GUEST_AMOUNT_DEFAULT_REQUEST, selectGuestsDefault);
  yield takeLatest(SELECT_DATE_REQUEST, selectDate);
  yield takeLatest(SELECT_DATE_DEFAULT_REQUEST, selectDateDefault);
  yield takeLatest(SELECT_PRODUCT_REQUEST, selectProduct);
  yield takeLatest(SELECT_PRODUCT_DEFAULT_REQUEST, selectProductDefault);
  yield takeLatest(SELECT_EXPERIENCE_REQUEST, selectExperience);
  yield takeLatest(SELECT_EXPERIENCE_DEFAULT_REQUEST, selectExperienceDefault);
  yield takeLatest(SELECT_SORT_TYPE_REQUEST, selectSortType);
  yield takeLatest(SELECT_SORT_TYPE_DEFAULT_REQUEST, selectSortTypeDefault);
  yield takeLatest(SELECT_DISTANCE_REQUEST, selectDistance);
  yield takeLatest(SELECT_DISTANCE_DEFAULT_REQUEST, selectDistanceDefault);
  yield takeLatest(SELECT_PRICE_REQUEST, selectPrice);
  yield takeLatest(SELECT_PRICE_DEFAULT_REQUEST, selectPriceDefault);
  yield takeLatest(OPEN_CHECKOUT_SUBSCRIPTION_PAGE, selectCardDefault);
}
